// Generated by Melange

import * as Caml_js_exceptions from "melange.js/caml_js_exceptions.js";
import * as Caml_obj from "melange.js/caml_obj.js";
import * as Js__Js_json from "melange.js/js_json.js";
import * as Mapre_web__Web_codec from "./web_codec.js";
import * as Mapre_wire__Json from "../../shared/wire/json.js";
import * as Stdlib__Array from "melange/array.js";
import * as Stdlib__Hashtbl from "melange/hashtbl.js";
import * as Stdlib__List from "melange/list.js";
import * as Stdlib__Option from "melange/option.js";

function find(t, seq) {
  return Stdlib__List.find_opt((function (p) {
    return p.seq === seq;
  }), t.items);
}

function attempt(t, seq) {
  return Stdlib__List.find_opt((function (a) {
    return a.seq === seq;
  }), t.attempts);
}

function persistent(choice) {
  if (choice.kind === /* Allow_always */ 1) {
    return true;
  } else {
    return choice.kind === /* Reject_always */ 3;
  }
}

function update(t, items) {
  if (/* tag */ typeof items !== "object" && typeof items !== "function") {
    switch (items) {
      case /* Keep_reviewing */ 1 :
        return {
          items: t.items,
          attempts: t.attempts,
          confirmation: undefined,
          message: t.message,
          denied: t.denied
        };
      case /* Denied */ 3 :
        return {
          items: t.items,
          attempts: /* [] */ 0,
          confirmation: undefined,
          message: "Permission denied. Refresh your access before replying.",
          denied: true
        };
      case /* Access_refreshed */ 4 :
        return {
          items: t.items,
          attempts: t.attempts,
          confirmation: t.confirmation,
          message: "",
          denied: false
        };
      default:
        return t;
    }
  } else {
    switch (items.TAG) {
      case /* Loaded */ 2 :
        const items$1 = items._0;
        const pending = Stdlib__Hashtbl.create(undefined, Stdlib__List.length(items$1));
        Stdlib__List.iter((function (p) {
          if (Caml_obj.caml_equal(p.decision, /* Pending */ 0)) {
            return Stdlib__Hashtbl.add(pending, p.seq, undefined);
          }
          
        }), items$1);
        return {
          items: items$1,
          attempts: Stdlib__List.filter((function (a) {
            return Stdlib__Hashtbl.mem(pending, a.seq);
          }), t.attempts),
          confirmation: t.confirmation,
          message: t.message,
          denied: t.denied
        };
      case /* Started */ 3 :
        const a = items._0;
        return {
          items: t.items,
          attempts: {
            hd: a,
            tl: Stdlib__List.filter((function (old) {
              return old.seq !== a.seq;
            }), t.attempts)
          },
          confirmation: undefined,
          message: "",
          denied: t.denied
        };
      case /* Phase */ 4 :
        const phase = items._1;
        const seq = items._0;
        return {
          items: t.items,
          attempts: Stdlib__List.map((function (a) {
            if (a.seq === seq) {
              return {
                seq: a.seq,
                command_id: a.command_id,
                expected_version: a.expected_version,
                option_id: a.option_id,
                phase
              };
            } else {
              return a;
            }
          }), t.attempts),
          confirmation: t.confirmation,
          message: t.message,
          denied: t.denied
        };
      case /* Failed */ 5 :
        const seq$1 = items._0;
        return {
          items: t.items,
          attempts: Stdlib__List.filter((function (a) {
            return a.seq !== seq$1;
          }), t.attempts),
          confirmation: undefined,
          message: items._1,
          denied: t.denied
        };
      case /* Message */ 6 :
        return {
          items: t.items,
          attempts: t.attempts,
          confirmation: t.confirmation,
          message: items._0,
          denied: t.denied
        };
      case /* Confirming */ 7 :
        return {
          items: t.items,
          attempts: t.attempts,
          confirmation: [
            items._0,
            items._1
          ],
          message: t.message,
          denied: t.denied
        };
      default:
        return t;
    }
  }
}

function kind(param) {
  switch (param) {
    case "allow_always" :
      return /* Allow_always */ 1;
    case "allow_once" :
      return /* Allow_once */ 0;
    case "reject_always" :
      return /* Reject_always */ 3;
    case "reject_once" :
      return /* Reject_once */ 2;
    default:
      throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
          MEL_EXN_ID: Mapre_wire__Json.Invalid,
          _1: "invalid_permission_kind"
        });
  }
}

function detail(tool) {
  const command = Mapre_web__Web_codec.text(Mapre_web__Web_codec.field(tool, "_meta"), "cognition.ai/editableCommand");
  if (command !== "") {
    return command;
  }
  const value = Mapre_web__Web_codec.field(tool, "rawInput");
  if (Caml_obj.caml_equal(value, null)) {
    return "";
  } else {
    return Stdlib__Option.value(Js__Js_json.decodeString(value), JSON.stringify(value));
  }
}

function decode(row) {
  const match = Mapre_wire__Json.string(row, "state");
  let decision;
  switch (match) {
    case "answered" :
      const login = Js__Js_json.decodeString(Mapre_web__Web_codec.field(row, "actor_login"));
      decision = {
        TAG: /* Answered */ 0,
        _0: Stdlib__Option.value(login, Mapre_wire__Json.string(row, "actor_id")),
        _1: Js__Js_json.decodeString(Mapre_wire__Json.get(row, "option_id"))
      };
      break;
    case "pending" :
      decision = /* Pending */ 0;
      break;
    default:
      throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
          MEL_EXN_ID: Mapre_wire__Json.Invalid,
          _1: "invalid_permission_state"
        });
  }
  return {
    seq: Mapre_wire__Json.integer(row, "seq"),
    run_id: Mapre_wire__Json.string(row, "run_id"),
    version: Mapre_wire__Json.integer(row, "version"),
    title: Mapre_wire__Json.string(row, "title"),
    detail: detail(Mapre_wire__Json.get(row, "tool_call")),
    options: Stdlib__Array.to_list(Stdlib__Array.map((function (value) {
      return {
        id: Mapre_wire__Json.string(value, "id"),
        name: Mapre_wire__Json.string(value, "name"),
        kind: kind(Mapre_wire__Json.string(value, "kind"))
      };
    }), Mapre_wire__Json.array(row, "options"))),
    decision
  };
}

function decision_text(item) {
  const match = item.decision;
  if (/* tag */ typeof match !== "object" && typeof match !== "function") {
    return "Permission requested";
  }
  const selected = match._1;
  let name;
  if (selected !== undefined) {
    const c = Stdlib__List.find_opt((function (c) {
      return c.id === selected;
    }), item.options);
    if (c !== undefined) {
      name = c.name;
    } else {
      throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
          MEL_EXN_ID: Mapre_wire__Json.Invalid,
          _1: "invalid_permission_decision"
        });
    }
  } else {
    name = "Cancelled";
  }
  return "Reply accepted by " + (match._0 + (": " + name));
}

const initial = {
  items: /* [] */ 0,
  attempts: /* [] */ 0,
  confirmation: undefined,
  message: "",
  denied: false
};

export {
  initial,
  find,
  attempt,
  persistent,
  update,
  decode,
  decision_text,
}
/* Mapre_web__Web_codec Not a pure module */
